import { ApiResponseError } from '../ApiResponseError';
import { VeriffVerificationSession } from './model/VeriffVerificationSession';
import { VeriffSessionRequest } from './model/VeriffSessionRequest';

export const getVeriffVerificationSession = async (
  veriffVerificationTrigger: VeriffSessionRequest,
): Promise<VeriffVerificationSession> => {
  const options: RequestInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(veriffVerificationTrigger),
    credentials: 'include',
  };
  const response = await fetch(`${process.env.VERIFF_SERVICE_BASE_URL}/api/session`, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as VeriffVerificationSession;
};
